module.exports = __webpack_public_path__ + "img/TMQ.9a2937c8.webp";